// extracted by mini-css-extract-plugin
export default {"Root":"CalcFactor_Root__T8IXu","Columns":"CalcFactor_Columns__lAHqm","Column":"CalcFactor_Column__pTnV+","Numpad":"CalcFactor_Numpad__EOlXq","Flex":"CalcFactor_Flex__Aj43l"};